import React from "react";
import { Box, Container, Grid, Paper, Toolbar } from "@mui/material";
import LabeledItem from "../Detail/LabeledItem";

type Item = {
  label: string;
  value?: React.ReactNode;
  isLoading: boolean;
  withDivider?: boolean;
};

type DetailLayoutProps = {
  toolbar: React.ReactNode;
  items: Item[];
};

const DetailLayout = ({ toolbar, items }: DetailLayoutProps) => {
  return (
    <Container maxWidth="md" sx={{ px: 0 }}>
      <Box>
        <Toolbar
          variant="dense"
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {toolbar}
        </Toolbar>
        <Paper>
          <Box sx={{ pt: 2 }}>
            <Grid container spacing={2} sx={{ pb: 1 }}>
              {items.map((item) => (
                <LabeledItem
                  key={`${item.label}`}
                  label={item.label}
                  value={item.value}
                  isLoading={item.isLoading}
                  withDivider={item.withDivider}
                />
              ))}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default DetailLayout;
